import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '浪漫爱情', path: '/category/romance' },
  { name: '奇幻冒险', path: '/category/fantasy' },
  { name: '悬疑惊悚', path: '/category/thriller' },
  { name: '都市职场', path: '/category/urban' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center">
              <i className={`ri-moon-line text-xl md:text-2xl ${scrolled ? 'text-primary-500' : 'text-white'}`}></i>
            </div>
            <span
              className={`text-lg md:text-xl font-heading font-bold tracking-wide transition-colors duration-300 ${
                scrolled ? 'text-foreground-900' : 'text-white'
              }`}
            >
              虚空韩漫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
              scrolled
                ? 'bg-primary-500 text-white hover:bg-primary-600'
                : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
            }`}>
              <i className="ri-bookmark-line mr-1.5"></i>
              我的书架
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${scrolled ? 'text-foreground-900' : 'text-white'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <button className="mt-2 px-4 py-2.5 text-sm font-medium bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-bookmark-line mr-1.5"></i>
              我的书架
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}